import { Theme, css } from "@emotion/react"

export const returnInputStyle = (
  theme: Theme,
  isValid: boolean,
  error: any
) => {
  return css`
    padding-left: 16px !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    width: 100%;
    font-family: Inter400;
    font-size: 14px;
    color: ${theme.colors.primary};
    border-radius: 4px;
    outline: 0;
    cursor: text;
    min-height: 56px;
    transition: all 0.2s ease;
    border: 1px solid
      ${error
        ? theme.colors.errorDark
        : isValid
          ? theme.colors.successDark
          : theme.colors.ctaInactive} !important;
    &:focus {
      border: 1px solid ${theme.colors.borderMedium} !important;
      box-shadow: 0 0 0 2px ${theme.colors.borderMedium} !important;
    }
    &:hover {
      border-color: ${theme.colors.ctaMain} !important;
    }
    &::placeholder {
      font-family: Inter400;
      color: ${theme.colors.secondary2};
      font-size: 14px;
    }
  `
}

export const returnCheckboxAndRadioStyle = (
  theme: Theme,
  borderRadius: string
) => {
  return css`
    &:hover {
      > .customElement {
        transition: all 0.2s ease-in-out;
        background-color: ${theme.colors.whiteHover};
      }
    }

    > input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    > input:checked ~ .customElement {
      background-color: ${theme.colors.ctaMain};
      &:hover {
        background-color: ${theme.colors.ctaMain};
      }
      transition: all 0.2s ease-in-out;
      box-shadow:
        0px 2px 4px 0px rgba(0, 0, 0, 0.4),
        0px 0px 0px 1px ${theme.colors.ctaSecondaryTwo};
      > .checkedIndicator {
        opacity: 100;
      }
    }
    > input:disabled ~ .customElement {
      background-color: ${theme.colors.ctaInactive};
      cursor: default;
      box-shadow:
        0px 2px 4px 0px rgba(0, 0, 0, 0.2),
        0px 0px 0px 1px ${theme.colors.greyBorder};
      > .checkedIndicator {
        opacity: 0;
      }
    }

    > input:disabled:checked ~ .customElement {
      /* Other styles */
      > .checkedIndicator {
        opacity: 100; /* Ensure the checkmark remains visible */
        color: ${theme.colors.secondary2};
      }
    }

    > input:checked ~ .checkedIndicator {
      opacity: 100;
    }

    > .customElement {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      width: 20px;
      min-width: 20px;
      min-height: 20px;
      box-shadow:
        0px 2px 4px 0px rgba(0, 0, 0, 0.2),
        0px 0px 0px 1px ${theme.colors.greyBorder};
      border-radius: ${borderRadius};
      > .checkedIndicator {
        opacity: 0;
        color: ${theme.colors.white};
      }
    }
  `
}
